import { Icon } from '@adobe/react-spectrum';

const ChevronLeft = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '6'}
        height={props.height || '6'}
        viewBox="0 0 6 6"
        fill="none"
      >
        <g clipPath="url(#clip0_4296_153115)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.01462 0.0385856C4.2031 0.0385856 4.37985 0.112316 4.51267 0.246596C4.64402 0.379896 4.71579 0.556166 4.71433 0.743176C4.71287 0.930185 4.63913 1.10548 4.50632 1.23634L2.72068 3.00001L4.49168 4.74903C4.62449 4.88038 4.69871 5.05567 4.69969 5.24268C4.70115 5.42969 4.62938 5.60596 4.49803 5.73877C4.36522 5.87305 4.18846 5.94727 3.99949 5.94727C3.81443 5.94727 3.63963 5.87549 3.50779 5.74512L1.23289 3.49805C1.09519 3.3584 1.02342 3.18213 1.02488 2.99512C1.02634 2.80811 1.10008 2.63282 1.23289 2.50196L3.52244 0.240236C3.65428 0.110356 3.82907 0.0385856 4.01462 0.0385856Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_4296_153115">
            <rect
              width="6"
              height="6"
              fill="white"
              transform="translate(6 6) rotate(-180)"
            />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
};

export default ChevronLeft;
